import { render, staticRenderFns } from "./ManageCoach.vue?vue&type=template&id=113c1e20&"
import script from "./ManageCoach.vue?vue&type=script&lang=js&"
export * from "./ManageCoach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports